module.exports = __webpack_public_path__ + "img/1440.6903d7e4.jpg";